<div class="modal-header">
  <h3 uni-heading color="primary">Carga de foto</h3>

  <button uni-icon-button variant="muted" aria-label="Cerrar" (click)="close()">
    <uni-icon name="x"></uni-icon>
  </button>
</div>
<div class="modal-body p-0">
  <video preload="none" [hidden]="!isCapturing" #player></video>

  <canvas [hidden]="true" #canvas></canvas>

  <div class="modal-container-spacer" *ngIf="!isCapturing">
    <image-cropper
      [autoCrop]="false"
      [imageURL]="imageDataUrl"
      format="png"
      [transform]="transform"
      [maintainAspectRatio]="false"
    >
    </image-cropper>

    <div class="edition-container">
      <div class="row mt-4">
        <div class="col-md-6">
          <div class="form-group">
            <div class="label-container">
              <label for="zoom">Zoom: </label> <span>{{ this.scale }}</span>
            </div>
            <input
              [value]="scale"
              (input)="onChangeZoom($event)"
              [min]="minScale"
              [max]="maxScale"
              step="0.1"
              id="zoom"
              type="range"
              [ngStyle]="{ backgroundSize: scalePercentage + '%' + ' 100%' }"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <div class="label-container">
              <label for="horintation">Enderezar: </label> <span>{{ this.rotation }}</span>
            </div>
            <input
              min="-50"
              max="50"
              step="1"
              [value]="rotation"
              id="horintation"
              type="range"
              (input)="onChangeRotation($event)"
              [ngStyle]="{ backgroundSize: rotationPercentage + '%' + ' 100%' }"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="container">
    <div class="pt-0 d-flex justify-content-between">
      <button uni-button (click)="close()" variant="secondary">Cancelar</button>
      <button uni-button (click)="isCapturing ? onCaptureImage() : saveImage()">
        {{ isCapturing ? "Tomar Foto" : "Guardar" }}
      </button>
    </div>
  </div>
</div>
